import React from 'react';

import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

interface Props {
  handleFlagChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  mark_cancelled?: boolean | null;
}

export default function BookingCancelledToggle({ handleFlagChange, mark_cancelled }: Props) {
  return (
    <Box id="BookingCancelledToggle">
      <FormControl component="fieldset">
        <FormLabel component="legend">Should the booking be cancelled?</FormLabel>
        <RadioGroup
          row
          name="mark_cancelled"
          value={mark_cancelled == null ? '' : Number(mark_cancelled).toString()}
          onChange={handleFlagChange}
        >
          <FormControlLabel
            value="1"
            control={<Radio inputProps={{ className: 'T-mark-cancelled-yes', required: true }} />}
            label="Yes"
          />

          <FormControlLabel
            value="0"
            control={<Radio inputProps={{ className: 'T-mark-cancelled-no' }} />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
